import React, { useState, useRef, useEffect } from "react"
import { Formik, Field, Form } from "formik"
import moment from "moment"
import {
  InputGroup,
  FieldWrappers,
  Label,
  SubmitBtn,
  Wrapper,
  CombineInputGroup,
  ActionSection,
  ScrollableContent,
  RupeeIcon,
} from "../Styles/InputStyles"
import { toast } from "react-toastify"
import { MdClose } from "react-icons/md"
import tw from "tailwind-styled-components"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import { FaUserPlus } from "react-icons/fa"
import DropZone from "../Notice/Dropzone"
import Checkbox from "@mui/material/Checkbox"
import ListItemText from "@mui/material/ListItemText"
import { Box, Button } from "@mui/material"
import DateRepetitionModal from "./DateRepetitionModal"
import Images from "../../Images"
import NewPayerDropdown from "../NewPayerDropdown"
import CategoryCard from "../CategoryCard"
import SelectCategoryModal from "./SelectCategoryModal"
import PaidUserModal from "./PaidUserModal"
import PaidToUserModal from "./PaidToUserModal"
import MultiPropSelectModal from "../MultiPropSelectModal"
import { paymentModes } from "../../helpers"

const AddExpenses = ({
  handleClose,
  expenseData,
  vendorList,
  categories,
  addExpenseMutate,
  addExpenseLoading,
  setIsAddVendor,
  property,
  landlordList
}) => {
  const formikRef = useRef(null)
  const [height, setHeight] = useState(window.innerHeight)
  const [tempSelectedProps, setTempSelectedProps] = useState([])
  const [propertySelectOpen, setPropertySelectOpen] = useState(false)
  const [showDateRepetitionModal, setShowDateRepetitionModal] = useState(false)
  const [showCategoryModal, setShowCategoryModal] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [selectedPaidBy, setSelectedPaidBy] = useState('')
  const [selectedPaidTo, setSelectedPaidTo] = useState('')
  const [showPaidModal, setShowPaidModal] = useState(false)
  const [showPaidToModal, setShowPaidToModal] = useState(false)
  const [showPropertyModal, setShowPropertyModal] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight)
    }
    window.addEventListener("resize", handleResize)
    handleResize()
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])
  const filteredProperties = property?.filter(prop => prop.id !== 0) || [];

  const initialValues = {
    amount: "",
    category: "",
    repetition: 1,
    noOfMonths: 0,
    paymentDate: new Date(),
    dueDate: new Date(),
    properties: [],
    paidBy: "",
    paidTo: "",
    paymentMode: "",
    description: "",
    file: null,
  }

  // const paymentModes = [
  //   { value: 1, label: "Offline", icon: <img src={Images.Offline} alt="Offline" className="w-10 h-10" /> },
  //   { value: 2, label: "UPI", icon: <img src={Images.UPI} alt="UPI" className="w-10 h-10" /> },
  //   { value: 3, label: "Net Banking", icon: <img src={Images.NetBanking} alt="Net Banking" className="w-10 h-10" /> },
  //   { value: 4, label: "Card", icon: <img src={Images.Card} alt="Card" className="w-10 h-10" /> },
  // ];

  const handleSubmit = (values) => {
    const amountRegex = /^(?!0+$)\d{1,6}$/
    const maxAmount = 1000000
    if (!amountRegex.test(values.amount) || parseInt(values.amount) > maxAmount) {
      toast.error("Amount must be between 1 and 10,00,000 and contain only numbers")
      return
    }
    if (!values.category) {
      toast.error("Category is required")
      return
    }
    if (!values.repetition) {
      toast.error("Repetition is required")
      return
    }
    if (values.repetition === 2 && (!values.noOfMonths || values.noOfMonths <= 0)) {
      toast.error("Number of months for repetition is required for monthly expenses")
      return
    }
    if (!values.paymentDate) {
      toast.error("Payment date is required")
      return
    }
    if (!values.paidBy) {
      toast.error("Paid by is required")
      return
    }
    if (!values.paidTo) {
      toast.error("Paid to is required")
      return
    }
    if (!values.paymentMode) {
      toast.error("Payment mode is required")
      return
    }
    const formData = new FormData()
    formData.append("amount", Number(values.amount))
    formData.append("type", Number(values.category))
    formData.append("repetitionType", Number(values.repetition))
    formData.append("description", values.description)
    formData.append("paidDate", moment(values.paymentDate).format("YYYY-MM-DD"))
    formData.append("dueDate", moment(values.dueDate).format("YYYY-MM-DD"))
    //formData.append("paidDate", moment(values.paymentDate).format("YYYY-MM-DD"))
    formData.append("paidBy", Number(values.paidBy))
    formData.append("paidTo", Number(values.paidTo))
    formData.append("paymentMode", values.paymentMode)
    if (!values.properties.includes(0)) {
      formData.append("propertyIds", values.properties.join(","));
    }
    formData.append("paidByUserType", Number(selectedPaidBy?.userType))
    formData.append("paidToUserType", Number(selectedPaidTo?.userType))
    if (values.repetition === 2 && values.noOfMonths) {
      formData.append("noOfMonths", Number(values.noOfMonths))
    }
    if (values.file) {
      formData.append("file", values.file[0])
    }
    addExpenseMutate(formData)
  }

  const handleSelectedProperties = (selectedProperties) => {
    if (formikRef.current) {
      formikRef.current.setFieldValue("properties", selectedProperties)
    }
  }

  const handlePropertySave = (properties) => {
    handleSelectedProperties(properties)
    setShowPropertyModal(false)
  }

  const handleSelectedPaidBy = (selectedOption) => {
    setSelectedPaidBy(selectedOption)

    if (formikRef.current) {
      formikRef.current.setFieldValue("paidBy", selectedOption.id)
    }
  }

  const handlePaidSave = (paid) => {
    handleSelectedPaidBy(paid)
    setShowPaidModal(false)
  }
  const handleSelectedPaidTo = (selectedOption) => {
    setSelectedPaidTo(selectedOption)
    if (formikRef.current) {
      formikRef.current.setFieldValue("paidTo", selectedOption.id)
    }
  }

  const handlePaidToSave = (paid) => {
    handleSelectedPaidTo(paid)
    setShowPaidToModal(false)
  }
  const handleSelectedCategory = (selectedOption) => {
    setSelectedCategory(selectedOption)
    if (formikRef.current) {
      formikRef.current.setFieldValue("category", selectedOption.value)
    }
  }

  const handleCategorySave = (category) => {
    handleSelectedCategory(category)
    setShowCategoryModal(false)
  }


  const handleDateRepetitionSave = (date, repetition, noOfMonths, dueDate) => {
    if (formikRef.current) {
      formikRef.current.setFieldValue("paymentDate", date)
      formikRef.current.setFieldValue("repetition", repetition)
      formikRef.current.setFieldValue("noOfMonths", noOfMonths)
      formikRef.current.setFieldValue("dueDate", dueDate)
    }
  }
  const renderSelectedProperties = (selected = []) => {
    if (!selected.length) return "Select Properties"
    const selectedProperties = filteredProperties?.filter((prop) => selected.includes(prop.id))
    if (!selectedProperties?.length) return "Select Properties"
    const maxToShow = 2
    const namesToShow = selectedProperties.slice(0, maxToShow).map((prop) => prop.name)
    const remainingCount = selectedProperties.length - maxToShow
    return (
      <div className="flex items-center gap-1 truncate">
        {namesToShow.join(", ")}
        {remainingCount > 0 && <span className="ml-1 text-gray-500">+{remainingCount}</span>}
      </div>
    )
  }

  return (
    <Container style={{ height: `${height}px`, overflow: "auto", WebkitOverflowScrolling: "touch" }}>
      <Header>
        <h1 className="text-lg font-medium text-white">Add Expense</h1>
        <button onClick={handleClose}>
          <MdClose color="white" size={24} />
        </button>
      </Header>
      <div className="custom-scrollbar flex h-full flex-col justify-between px-6">

        <Formik innerRef={formikRef} initialValues={initialValues} onSubmit={handleSubmit}>
          {({ values, setFieldValue }) => (
            <Form>
              <ScrollableContent className="max-h-[calc(100vh-140px)]">
                <Wrapper>
                  <InputGroup>
                    <Label htmlFor="category">Category *</Label>
                    <CategoryCard type="button" selectedCategory={selectedCategory} title="Category" onClick={() => setShowCategoryModal(true)} />
                  </InputGroup>

                  <InputGroup>
                    <Label htmlFor="amount">Amount *</Label>
                    <FieldWrappers>
                      <RupeeIcon />
                      <Field
                        type="text"
                        name="amount"
                        id="amount"
                        autoComplete="off"
                        className="w-full truncate pl-6"
                      />
                    </FieldWrappers>
                  </InputGroup>
                  <InputGroup>
                    <Label htmlFor="paidBy">Paid by *</Label>
                    <CategoryCard type="button" selectedCategory={selectedPaidBy} title="Paid By" onClick={() => setShowPaidModal(true)} />
                  </InputGroup>

                  <InputGroup>
                    <Label htmlFor="paidTo">Paid to *</Label>
                    <CategoryCard type="button" selectedCategory={selectedPaidTo} title="Paid To" onClick={() => setShowPaidToModal(true)} />

                  </InputGroup>

                  <div className="-mt-2 flex items-end justify-end">
                    <Vendor
                      type="button"
                      onClick={() => {
                        setIsAddVendor(true)
                      }}
                    >
                      <FaUserPlus className="mr-1 mt-0.5" />
                      Add Vendor
                    </Vendor>
                  </div>

                  <InputGroup>
                    <Label>Select property/properties (optional)</Label>
                    <CategoryCard
                      type="button"
                      selectedCategory={values.properties.length > 0 ? {
                        label: renderSelectedProperties(values.properties),
                        value: "properties"
                      } : null}
                      title="Property/or Properties"
                      onClick={() => setShowPropertyModal(true)}
                    />
                  </InputGroup>

                  <InputGroup>
                    <Label>Payment Mode *</Label>
                    <PaymentModeWrapper>
                      {paymentModes.map((mode) => (
                        <PaymentModeCard
                          key={mode.value}
                          type="button"
                          onClick={(e) => {
                            e.preventDefault()
                            setFieldValue("paymentMode", mode.value, false)
                          }}
                          className={
                            values.paymentMode === mode.value ? "bg-blue-200" : "bg-gray-100"
                          }
                        >
                          <span className="text-sm">{mode.label}</span>
                        </PaymentModeCard>
                      ))}
                    </PaymentModeWrapper>
                  </InputGroup>
                  <InputGroup>
                    <Label htmlFor="description">Description (optional)</Label>
                    <Field
                      as={Textarea}
                      id="description"
                      name="description"
                      rows={5}
                      placeholder="Enter Description"
                    />
                  </InputGroup>
                  <InputGroup>
                    <Label htmlFor="file">Document(optional)</Label>
                    <FieldWrapper $select={true}>
                      <Field
                        required
                        name="file"
                        type="text"
                        id="file"
                        autoComplete="off"
                      >
                        {(props) => (
                          <DropZone
                            fields={props.field}
                            setFieldValue={props.form.setFieldValue}
                            componentFor="expense"
                            acceptedFiles="image/*,application/pdf"
                            File={props.field.value ? [props.field.value] : null}
                          />
                        )}
                      </Field>
                    </FieldWrapper>
                  </InputGroup>
                </Wrapper>
              </ScrollableContent>
              <ActionSection>
                <ExpenseDateRepetitionBtn type="button" onClick={() => setShowDateRepetitionModal(true)}>
                  Expense Date / Repetition
                  <div className="text-sm text-gray-800 mt-1">
                    {values.paymentDate
                      ? moment(values.paymentDate).format("YYYY-MM-DD")
                      : ""}
                    {" / "}
                    {values.repetition === 1
                      ? "One Time"
                      : values.repetition === 2 && values.noOfMonths
                        ? `Recurring`
                        : ""}
                  </div>
                </ExpenseDateRepetitionBtn>
                <SubmitBtn type="submit" disabled={addExpenseLoading}>
                  {addExpenseLoading ? "Submiting..." : "Submit"}
                </SubmitBtn>
              </ActionSection>
              <DateRepetitionModal
                isOpen={showDateRepetitionModal}
                onClose={() => setShowDateRepetitionModal(false)}
                onSave={handleDateRepetitionSave}
                initialDate={values.paymentDate}
                initialRepetition={values.repetition}
                initialNoOfMonths={values.noOfMonths}
              />
              <SelectCategoryModal
                isOpen={showCategoryModal}
                onClose={() => setShowCategoryModal(false)}
                onSelect={handleCategorySave}
                categories={categories}
                selectedCategory={selectedCategory}
              />
              <PaidUserModal
                isOpen={showPaidModal}
                onClose={() => setShowPaidModal(false)}
                onSelect={handlePaidSave}
                options={expenseData?.users}
                selectedPaidBy={selectedPaidBy}
              />
              <PaidToUserModal
                isOpen={showPaidToModal}
                onClose={() => setShowPaidToModal(false)}
                onSelect={handlePaidToSave}
                options={vendorList || expenseData?.vendors}
                landlordList={expenseData?.landlords}
                selectedPaidTo={selectedPaidTo}
                title="Select Paid To"
              />
              <MultiPropSelectModal
                isOpen={showPropertyModal}
                onClose={() => setShowPropertyModal(false)}
                onSelect={handlePropertySave}
                options={filteredProperties}
                selectedProperties={values.properties}
              />

            </Form>
          )}
        </Formik>
      </div>
    </Container>
  )
}

const Container = tw.div`bg-white w-full h-full flex flex-col relative`
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`
const Textarea = tw.textarea`min-h-10 max-h-40 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600  focus:border-sky-600 focus:outline-none duration-200 w-full h-20 resize-y break-words overflow-hidden`
const PaymentModeWrapper = tw.div`grid grid-cols-4 gap-2 my-1.5`
const PaymentModeCard = tw.button`flex flex-col items-center justify-center p-2 border rounded-lg shadow-sm cursor-pointer`
const Vendor = tw.button`text-blue-500 text-sm flex hover:underline`
const FieldWrapper = tw.div`w-full`
const ExpenseDateRepetitionBtn = tw.button`
  flex items-center justify-center flex-col
  px-4 py-2
  text-sm font-medium text-gray-600
  bg-white 
  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
  disabled:opacity-50
`

export default AddExpenses
